
Mindbreeze.define('libs/apm/softwaretelemetry',[], function () {

  var enabled = typeof $$APP_TELEMETRY_ENABLED$$ === "undefined" || $$APP_TELEMETRY_ENABLED$$;

  if (typeof window === "undefined" || !enabled) {
    return {
      env: {
        active: false
      },
      RegisterApplication: function () {},
      RegisterModule: function () {
        return {
          RegisterEvent: function () {
          }
        }
      },
      GetContext: function () {
      },
      CreateContext: function () {
        return 1;
      },
      ReleaseContext: function () {
      },
      Flush: function () {
      },
      AttachContext: function () {
      }
    };
  }
/**
@license Copyright (c) Fabasoft R&D GmbH, A-4020 Linz, 1988-2017.

Version: 17.2.7

All rights reserved. All hardware and software names used are registered
trade names and/or registered trademarks of the respective manufacturers.

The user of this computer program acknowledges that the above copyright
notice, which constitutes the Universal Copyright Convention, will be
attached at the position in the function of the computer program which the
author has deemed to sufficiently express the reservation of copyright.
It is prohibited for customers, users and/or third parties to remove,
modify or move this copyright notice.
*/
/*global console, alert, ActiveXObject, FscPluginGet */
(function (window, document) {
  "use strict";
  var TELEMETRY_STATUS_VALID_DAYS = 3;
  var apm, cache, env, utils, defaultTransport;
  var nop = function() { };
  var telemetryStatusKeyPrefix = "_apm:telemetryStatus";
  var apmguidKey = "_apm:guid", _base64Key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var SWT_ENTRY_GET_CONTEXT = 5,
      SWT_ENTRY_ATTACH_CONTEXT = 6,
      SWT_ENTRY_EVENT = 7,
      SWT_ENTRY_CREATE_CONTEXT = 8,
      SWT_ENTRY_RELEASE_CONTEXT = 9,
      SWT_ENTRY_GET_SYNC_MARK = 15,
      SWT_ENTRY_SET_SYNC_MARK = 16,
      SWT_ENTRY_REPORT = 18,
      SWT_ENTRY_REPORT_VALUE = 19;
  /**
  * ts - get current timestamp
  * @returns current timestamp
  */
  var ts = Date.now ? Date.now : function () {
    return (new Date()).getTime();
  };
  var expando = (function() {
    var now = ts();
    while ('apm' + now in window) {
      now++;
    }
    return 'apm' + now;
  }());
  // local internal helper functions for serialization of APM data for webAPI
  function _APMEvent(_contextid, _module, _id, _level, _flags, _params) {
    var result = [SWT_ENTRY_EVENT, ts(), cache.logicalclock++, _contextid,
      _module, _id, _level, _flags,];
    if (_params && _params.length > 0) {
      for (var idx in _params) {
        if (_params.hasOwnProperty(idx)) {
          result.push(_params[idx]);
        }
      }
    }
    return result;
  }
  function APMModule(_id, _name) {
    this.id = _id;
    this.name = _name;
    this.events = {};
    this.RegisterEvent = function (id, name, param) {
      this.events[+id] = [+id, name, param,];
      cache.register = true;
    };
    this._serialize = function () {
      var result = [this.id, this.name,];
      if (!cache.registration.blacklistmodules) {
        result.push(utils.arrayFromObject(this.events));
      }
      return result;
    };
    this.Event = function (_contextid, _id, _level, _flags) {
      if (!env.active) { return; }
      _level = isNaN(_level) ? 50 : _level;
      var tracelevel = cache.context["id" + _contextid];
      if (typeof _contextid === "number" && ((tracelevel == null && _level === 0) || tracelevel >= _level)) {
        _flags = isNaN(_flags) ? 0 : _flags;
        var params = null;
        if (arguments.length > 4) {
          params = [];
          var nNullParams = 0, val;
          for (var i = 4; i < arguments.length; i++) {
            val = arguments[i];
            if ((null != val) && ('undefined' !== typeof val)) {
              for (var j = 0; j < nNullParams; j++) {
                params.push("");
              }
              nNullParams = 0;
              if (typeof val === "object") {
                try {
                  val = "unsupported data type 'object': " + JSON.stringify(val);
                } catch (ex) {
                  val = "unsupported data type 'object'";
                }
                if (val.length > 200) { val = val.substr(0,197) + "..."; }  // truncate (objects may be huge)
                _flags |= apm.FLAG_WARNING;
              } else if (typeof val === "number") {
                if (!utils.isInt(val)) {
                  val = "unsupported data type 'float': " + val;
                  _flags |= apm.FLAG_WARNING;
                }
              }
              params.push(val);
            }
            else {
              nNullParams++;
            }
          }
        }
        cache._add(_APMEvent(_contextid, this.id, +_id, _level, _flags, params));
      }
    };
  }
  function _APMContext(_id, _contextid, _token) {
    return [_id, ts(), cache.logicalclock++, _contextid, _token,];
  }
  function _APMCreateContext(_contextid, _filter, _sessions) {
    var result = [SWT_ENTRY_CREATE_CONTEXT, ts(), cache.logicalclock++, _contextid, _filter,];
    if (_sessions && _sessions.length) {
      result.push(_sessions);
    }
    return result;
  }
  function _APMReleaseContext(_contextid) {
    return [SWT_ENTRY_RELEASE_CONTEXT, ts(), cache.logicalclock++, _contextid,];
  }
  function _APMReport(_contextid, _filtervalue, _reportkey, _description, _formid) {
    var arr = [SWT_ENTRY_REPORT, ts(), cache.logicalclock++, _contextid,
      _filtervalue, _reportkey, _description,];
    if (_formid) {
      arr.push(_formid);
    }
    return arr;
  }
  function _APMReportValue(_contextid, _reportkey, _key, _value) {
    return [SWT_ENTRY_REPORT_VALUE, ts(), cache.logicalclock++, _contextid,
      _reportkey, _key, _value,];
  }
  function CreateContextToken(level) {
    var output = "";
    for (var i = 0; i < 16; i++) {
      if (i === 15 && 'number' === typeof level) {
        output += String.fromCharCode(level);
      }
      else {
        output += String.fromCharCode(Math.floor(Math.random() * 256));
      }
    }
    return output;
  }

  function Encode64(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      }
      else {
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        if (isNaN(chr3)) {
          enc4 = 64;
        }
        else {
          enc4 = chr3 & 63;
        }
      }
      output += _base64Key.charAt(enc1) +
                  _base64Key.charAt(enc2) +
                  _base64Key.charAt(enc3) +
                  _base64Key.charAt(enc4);
    }
    return output;
  }
  function Decode64(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = _base64Key.indexOf(input.charAt(i++));
      enc2 = _base64Key.indexOf(input.charAt(i++));
      enc3 = _base64Key.indexOf(input.charAt(i++));
      enc4 = _base64Key.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output += String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output += String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output += String.fromCharCode(chr3);
      }
    }
    return output;
  }

  function b64ctx(level) {
    return Encode64(CreateContextToken(level));
  }

  env = {
    url: "web.telemetry",
    flushinterval: 60000,
    flushtimeout: 4000,
    eventsperflush: 10000,
    reregistermodulestimeout: 0,
    reregistertimeout: 600000,
    active: true,
    exceptioncallback: null,
    includeNavigationTiming: false,
    createContextFromNavigationTiming: true,
    report: {
      enabled: true,
      dialogtitle: 'Application Feedback',
      dialogpoweredby: 'powered by',
      dialogtext: 'Let us know your feedback:',
      dialogtextminlength: 0,
      dialogtextmaxlength: 1000,
      dialogtexttooshort: 'The feedback you entered is too short.',
      dialogsubmittext: 'Send',
      dialogcanceltooltip: 'Cancel',
      closeonescape: true,
      reportingunavailable: 'The feedback functionality is currently unavailable.',
      imagepath: null,
      onopen: null,
      onsubmit: null,
      oncancel: null,
      onclose: null,
      onavailable: null,
      dialognode: null,
      highcontrast: null, // (null|"bright"|"dark")
      screenshot: {
        enabled: true,
        label: 'Include Screenshot',
        previewlabel: 'Preview',
      },
      softwareinfo: {
        enabled: true,
        label: 'Include Software Repository/Registry',
        previewlabel: 'Preview',
      },
      displaymetadata: true,
      metadatatitle: 'Your feedback will include the following information:',
      filestitle: 'You can attach the following files to your feedback:',
      data: {
        contextid: null,
        filter: null,
        key: null,
        description: '',
      },
      pluginactive: false,
      plugin: null,
    },
  };
  cache = {
    procid: null,
    logicalclock: 0,
    events: null,
    context: {},
    contextid: 1,
    connected: false,
    registration: {
      appname: undefined,
      appid: undefined,
      apptiername: undefined,
      apptierid: undefined,
      modules: {},
      filters: {},
      modulecount: 0,
      timestamp: 0,
      blacklistmodules: false,
    },
    register: false,
    sendregistration: true,
    sessions: null,
    loglevel: 0,
    guid: null,
    jsonpid: 1,
    hasform: false,
    dlgApi: null,
    dlgCfg: false,
    flushintervalhandle: 0,
    flushtimeouthandle: 0,
    reregistertimeouthandle: 0,
    initialized: false,
    firstrequest: true,
    flushing: false,
    fbavailable: function(api) {
      cache.dlgApi = api;
      try {
        if (env.report.onavailable) {
          env.report.onavailable();
        }
      }
      catch (_) {
        utils.error(_, 'report.onavailable callback failed');
      }
    },
    processWebAPIResponse: function(json) {
      this.sessions = json.sessions;
      if ('number' === typeof json.loglevel) {
        this.loglevel = json.loglevel;
      }
      this.guid = json.GUID;
      this.hasform = json.hasform;
    },
    flush: function (flushAllEvents, isUnload) {
      if (!cache.flushing || flushAllEvents) {
        cache.flushing = true;
        try {
          if (cache.flushtimeouthandle !== 0) {
            window.clearTimeout(cache.flushtimeouthandle);
            cache.flushtimeouthandle = 0;
          }
          if (!env.active) { return; }
          var now = new Date();
          var strnow = now.getUTCFullYear() + "-" +
                        (now.getUTCMonth() + 1) + "-" +
                        now.getUTCDate() + "T" +
                        now.getUTCHours() + ":" +
                        now.getUTCMinutes() + ":" +
                        now.getUTCSeconds() + "." +
                        now.getUTCMilliseconds();
          var arrHeader = [apm.version, now.getTime(), 1000, strnow, cache.guid,];
          var arrRegister = [
            cache.procid,
            cache.registration.appname,
            cache.registration.appid,
            cache.registration.apptiername,
            cache.registration.apptierid,];
          if (cache.register || cache.sendregistration || (now - cache.registration.timestamp) > env.reregistermodulestimeout) {
            cache.registration.blacklistmodules = false;
            if (!cache.register && !cache.sendregistration && (now - cache.registration.timestamp) < env.reregistertimeout) {
              cache.registration.blacklistmodules = true;
            }
            arrRegister.push(cache.registration.filters);
            var arrModules = [];
            arrRegister.push(arrModules);
            for (var idx in cache.registration.modules) {
              if (cache.registration.modules.hasOwnProperty(idx)) {
                arrModules.push(cache.registration.modules[idx]._serialize());
              }
            }
            cache.sendregistration = false;
            cache.register = false;
            cache.registration.timestamp = now;
          }
          var content = [arrHeader, arrRegister,];
          if (cache.events) {
            var items = cache.events.splice(0, flushAllEvents ? cache.events.length : env.eventsperflush);
            if (cache.events.length > 0) {
              utils.setupTimeout();
            }
            if (items && items.length) {
              content.push(items);
            }
          }
          cache.transport.send(env.url, JSON.stringify({ "apm": content, }), function(response) {
            try {
              cache.connected = true;
              if (response.responseText) {
                var json = JSON.parse(response.responseText);
                utils.PersistTelemetryStatus(cache.registration, json);
                cache.processWebAPIResponse(json);
                utils.StoreGUID(json.GUID);
                if (true === env.report.enabled && ((true === cache.hasform || false === cache.hasform) && false === cache.dlgCfg)) {
                  cache.dlgCfg = null;
                  loadJSONP('?RESOURCE&file=apmdialog.json', function(data) {
                    cache.dlgCfg = data;
                    fetchDialogResources(data);
                  });
                }
                if (0 === json.logpool) {
                  cache.connected = false;
                }
              }
            }
            catch (e2) {
              cache.connected = false;
              utils.error(e2, "cache.flush(): transport.send failed: " + e2.name + ": " + e2.message);
            }
          }, function(response) {
            cache.connected = false;
            // request was not successful... data has been lost
            try {
              utils.error(null, "cache.flush(): transport.send: status=" + response.status + "; statusText='" + response.statusText + "'");
            }
            catch (e3) {
              utils.error(null, "cache.flush(): transport.send: status!=200, Exception: " + e3.name + ": '" + e3.message + "'");
            }
          }, true, isUnload);
          cache._reregistertimeout();
        }
        catch (e) {
          cache.connected = false;
          utils.error(e, "cache.flush() failed: " + e.name + ": " + e.message);
        }
        cache.flushing = false;
      }
    },
    _reregistertimeout: function () {
      if (cache.reregistertimeouthandle === 0) {
        cache.reregistertimeouthandle = window.setInterval(function () {
          cache.sendregistration = true;
        }, env.reregistertimeout); //send registration every 10 minutes
      }
    },
    _add: function (evt) {
      if (!env.active) { return; }
      if (!cache.events) {
        cache.events = [];
      }
      cache.events.push(evt);
    },
    _init: function () {
      if (!cache.initialized) {
        if (window.addEventListener) {
          window.addEventListener("unload", utils.flushAllEvents, false);
        }
        else if (window.attachEvent) {
          window.attachEvent("onunload", utils.flushAllEvents);
        }
        cache.initialized = true;
        utils.setupInterval();
        utils.RestoreGUID();
      }
    },
  };

  function loadJSONP(url, callback) {
    var scr, cbName, publicName;
    cbName = 'jsonp_callback_' + (cache.jsonpid++);
    apm.cache[cbName] = function() {
      delete apm.cache[cbName];
      if (scr.parentNode) {
        scr.parentNode.removeChild(scr);
      }
      scr = null;
      callback.apply(this, arguments);
    };
    publicName = 'window.' + expando + '.cache.' + cbName;
    scr = document.createElement('script');
    scr.type = "text/javascript";
    scr.async = true;
    scr.src = utils.buildURL(url + '&callback=' + encodeURIComponent(publicName));
    document.body.appendChild(scr);
  }

  function fetchDialogResources(d) {
    var i, el = null, prop = null, head = document.getElementsByTagName('head')[0], version = '';
    if (d && d.assets) {
      if (cache.dlgCfg && cache.dlgCfg.version) {
        version = '&v=' + encodeURIComponent(cache.dlgCfg.version);
      }
      for (i = 0; i < d.assets.length; ++i) {
        switch (d.assets[i].type) {
        case "js":
          el = document.createElement('script');
          el.async = true;
          el.type = 'text/javascript';
          prop = 'src';
          break;
        case "css":
          el = document.createElement('link');
          el.async = true;
          el.rel = 'stylesheet';
          prop = 'href';
          break;
        }
        if (el) {
          try {
            el.setAttribute('data-target-api', expando);
          }
          catch(_){}
          el[prop] = utils.buildURL('?RESOURCE&file=' + encodeURIComponent(d.assets[i].name) + version);
          head.appendChild(el);
          el = null;
        }
      }
    }
  }

  // global variables stored in global object "apm"
  var navTCtx, navTCtxBackup;
  apm = {
    version: "17.2.7",
    LEVEL_LOG: 0,
    LEVEL_NORMAL: 50,
    LEVEL_DETAIL: 60,
    LEVEL_DEBUG: 70,
    FLAG_NONE: 0,
    FLAG_ENTER: 1,
    FLAG_LEAVE: 2,
    FLAG_WAIT: 4,
    FLAG_WARNING: 8,
    FLAG_ERROR: 16,
    FLAG_PROCESS_INFO: 32,
    EVENT_ERROR: 0x10001000,
    EVENT_WARNING: 0x10001001,
    EVENT_INFO: 0x10001002,
    EVENT_TRACE: 0x10001003,
    env: env,
    cache: {
      $jq: null,
      fbavailable: function() {
        return cache.fbavailable.apply(cache, arguments);
      },
    },
    NoConflict: function() {
      // only reset the global apm if we are the current "owner"
      if (window.apm === apm) {
        window.apm = apm._apm;
      }
      return apm;
    },
    SetTransport: function(transport) {
      var oldTransport = cache.transport;
      if (transport) {
        cache.transport = transport;
      }
      else {
        cache.transport = defaultTransport;
      }
      cache.sendregistration = true;
      return oldTransport;
    },
    RegisterApplication: function (appname, appid, apptiername, apptierid) {
      cache._init();
      if (!cache.procid) {
        cache.procid = b64ctx();
      }
      cache.registration.appname = appname;
      cache.registration.appid = appid;
      cache.registration.apptiername = apptiername;
      cache.registration.apptierid = apptierid;
      cache.register = true;
      utils.RestoreTelemetryStatus(cache.registration);
    },
    RegisterModule: function (modulename) {
      var module = cache.registration.modules[modulename];
      if (!module) {
        var moduleid = cache.registration.modulecount++;
        module = new APMModule(moduleid, modulename);
        cache.registration.modules[modulename] = module;
        cache.register = true;
      }
      return module;
    },
    RegisterFilterValue: function (value, description) {
      cache.registration.filters[value] = description;
      cache.register = true;
    },
    CreateContext: function (_contextid, _filter) {
      if (!env.active) { return null; }
      //var logmsg = "apm.CreateContext("+_contextid+", " + _filter + ")";
      utils.setupTimeout();
      var sessions = cache.sessions;
      var level = cache.loglevel;
      if (_contextid == null || cache.context["id" + _contextid] == null) {
        _contextid = ++cache.contextid;
        cache.context["id" + _contextid] = level;
      }
      var sessionids = [];
      if (sessions != null) {
        for (var idx = 0; idx < sessions.length; idx++) {
          var session = sessions[idx];
          if (session != null && typeof session === 'object' && typeof session.id === 'number' && typeof session.level === 'number') {
            if (typeof session.filters === 'object' && session.filters.length > 0) {
              for (var idx2 = 0; idx2 < session.filters.length; idx2++) {
                var value = session.filters[idx2];
                if (value.length === 0 || _filter.toLowerCase() === value.toLowerCase()) {
                  sessionids.push(session.id);
                  if (session.level > level) {
                    level = session.level;
                  }
                  break;
                }
              }
            }
            else {
              sessionids.push(session.id);
              if (session.level > level) {
                level = session.level;
              }
            }
          }
        }
      }
      if (cache.context["id" + _contextid] < level) {
        cache.context["id" + _contextid] = level;
      }
      if (env.createContextFromNavigationTiming && cache.firstrequest) {
        cache.firstrequest = false;
        if (window.performance && window.performance.timing && window.performance.timing.navigationStart) {
          var t = window.performance.timing;
          var c = _APMCreateContext(_contextid, "");
          c[1] = t.navigationStart;
          cache._add(c);
          utils.TraceNavigationTiming(_contextid);
        }
      }
      cache._add(_APMCreateContext(_contextid, _filter, sessionids));
      if (env.includeNavigationTiming && navTCtx) {
        cache._add(_APMContext(SWT_ENTRY_GET_CONTEXT, _contextid, navTCtx));
      }
      navTCtx = null;
      //console.log(logmsg + " -> " + _contextid);
      return _contextid;
    },
    GetContext: function (_contextid) {
      if (!env.active) { return null; }
      utils.setupTimeout();
      var _token = null;
      if (cache.context["id" + _contextid] != null) {
        _token = b64ctx(cache.context["id" + _contextid]);
        cache._add(_APMContext(SWT_ENTRY_GET_CONTEXT, _contextid, _token));
      }
      //console.log("apm.GetContext("+_contextid+") -> " + _token);
      return _token;
    },
    AttachContext: function (_contextid, _token) {
      if (!env.active) { return _contextid; }
      //var logmsg = "apm.AttachContext("+_contextid+", " + _token + ")";
      utils.setupTimeout();
      if (_contextid == null || cache.context["id" + _contextid] == null) {
        _contextid = ++cache.contextid;
      }
      var level = apm.LEVEL_NORMAL;
      if (_token != null) {
        var bintoken = utils.Decode64(_token);
        level = bintoken.charCodeAt(15);
      }
      if (cache.context["id" + _contextid] == null || cache.context["id" + _contextid] < level) {
        cache.context["id" + _contextid] = level;
      }
      cache._add(_APMContext(SWT_ENTRY_ATTACH_CONTEXT, _contextid, _token));
      //console.log(logmsg + " -> " + _contextid);
      return _contextid;
    },
    ReleaseContext: function (_contextid) {
      if (!env.active) { return; }
      //console.log("apm.ReleaseContext(" + _contextid + ")");
      utils.setupTimeout();
      if (cache.context["id" + _contextid] != null) {
        cache._add(_APMReleaseContext(_contextid));
        delete cache.context["id" + _contextid];
      }
      if (cache.connectioncontextid == _contextid) {
        cache.connectioncontextid = null;
      }
    },
    GetSyncMark: function (_contextid) {
      if (!env.active) { return null; }
      var _token = null;
      if (cache.context["id" + _contextid] != null) {
        _token = b64ctx();
        cache._add(_APMContext(SWT_ENTRY_GET_SYNC_MARK, _contextid, _token));
      }
      return _token;
    },
    SetSyncMark: function (_contextid, _token) {
      if (!env.active) { return; }
      if (cache.context["id" + _contextid] != null) {
        cache._add(_APMContext(SWT_ENTRY_SET_SYNC_MARK, _contextid, _token));
      }
    },
    Report: function (_contextid, _filter, _reportkey, _description /* _formid */) {
      if (!env.active) { return; }
      cache._add(_APMReport(_contextid, _filter, _reportkey, _description, arguments[4]));
    },
    ReportValue: function (_contextid, _reportkey, _key, _value) {
      if (!env.active) { return; }
      cache._add(_APMReportValue(_contextid, _reportkey, _key, _value));
    },
    ReportContent: function (_reportkey, _filename, _value, _encoding, _mimetype) {
      if (!env.active) { return; }
      var url = "?ReportContent";
      if (cache.procid !== null) {
        url += "&procid=" + encodeURIComponent(cache.procid);
      }
      url += "&reportkey=" + encodeURIComponent(_reportkey);
      url += "&filename=" + encodeURIComponent(_filename);
      var enc = _encoding ? _encoding : "plaintext";
      url += "&encoding=" + encodeURIComponent(enc);
      var mime = _mimetype ? _mimetype : "text/plain";
      url += "&mimetype=" + encodeURIComponent(mime);
      cache.transport.send(utils.buildURL(url), _value, nop, nop, true);
    },
    ReportDialog: function (_contextid, _filter, _reportkey, _description, _parentNode, _metadata, _formOptions) {
      var r = env.report, $ = utils.get$();
      if (!env.active) { return; }
      if (!apm.IsConnected() || !$ || !$.fn.apmfeedbackdialog || !cache.dlgApi) {
        alert(env.report.reportingunavailable);
        return;
      }
      if (_contextid == null) {
        _contextid = apm.CreateContext(null, _filter);
      }
      var module = apm.GetAPMModule();
      module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_NONE, "Prepare app.telemetry feedback dialog");

      r.data.contextid = _contextid;
      r.data.filter = _filter;
      r.data.key = _reportkey || b64ctx();
      r.data.description = _description;

      r.pluginactive = false;
      r.plugin = null;
      try {
        apm._detectFscPlugin();
        r.plugin = FscPluginGet();
        if (r.plugin !== null) {
          r.pluginactive = true;
        }
      } catch (e) { }
      var plugin = r.plugin;
      if (r.pluginactive) {
        if (r.screenshot.enabled) {
          try {
            if (plugin && plugin.GetScreenshot && typeof plugin.GetScreenshot === "function") {
              module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_ENTER, "app.telemetry feedback dialog calls plugin.GetScreenshot()");
              r.data.screenshot = plugin.GetScreenshot(); // provides an object: { file, size, extension, mimetype, content }
              module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_LEAVE, "app.telemetry feedback dialog calls plugin.GetScreenshot() done");
            }
          } catch (e2) {
            r.data.screenshot = null;
          }
        }
        if (r.softwareinfo.enabled) {
          try {
            if (plugin && plugin.GetSystemInformation && typeof plugin.GetSystemInformation === "function") {
              module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_ENTER, "app.telemetry feedback dialog calls plugin.GetSystemInformation()");
              r.data.softwareinfo = plugin.GetSystemInformation(); // provides an object: { file, size, extension, mimetype, content }
              module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_LEAVE, "app.telemetry feedback dialog calls plugin.GetSystemInformation() done");
            }
          } catch (e3) {
            r.data.softwareinfo = null;
          }
        }
      }
      if (_metadata) {
        r.data.metadata = _metadata;
      }
      module.Event(_contextid, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_ENTER, "Create app.telemetry feedback dialog");
      utils.createReportDialog(_parentNode, _formOptions);
      return r.data.key;
    },
    HasActiveContext: function (_contextid, level) {
      if (!env.active) { return false; }
      var ctxlevel = cache.context["id" + _contextid];
      if (ctxlevel != null) {
        return ctxlevel >= level;
      }
      else {
        return level === 0;
      }
    },
    IsConnected: function () {
      return env.active && cache.connected;
    },
    SetConnectionContext: function () {
    },
    GetConnectionContext: function () {
      return null;
    },
    SendXMLHttpRequest: function (request, async, value, callback, context) {
      var _context = context, token, module;
      if (env.active && async) {
        token = this.GetContext(context);
        _context = this.AttachContext(null, token);
      }
      module = apm.GetXMLHTTPModule();
      if (env.active || ('function' === typeof callback)) {
        request.onreadystatechange = function () {
          if (env.active) {
            if (request.readyState !== 4) {
              module.Event(_context, request.readyState, apm.LEVEL_DEBUG, apm.FLAG_NONE);
              if ('function' === typeof callback) {
                module.Event(_context, 10, apm.LEVEL_DEBUG, apm.FLAG_ENTER);
                try {
                  callback(request, _context);
                }
                catch (e) {
                  var msg = "apm.SendXMLHttpRequest user callback failed: " + e.name + ": " + e.message;
                  utils.error(e, msg);
                  module.Event(_context, apm.EVENT_ERROR, apm.LEVEL_DEBUG, apm.FLAG_NONE, msg);
                }
                module.Event(_context, 11, apm.LEVEL_DEBUG, apm.FLAG_LEAVE);
              }
            }
            else {
              var syncmark = request.getResponseHeader("x-apm-telemetry-syncmark");
              if (syncmark) {
                apm.SetSyncMark(_context, syncmark);
              }
              try {
                // accessing request.statusText might throw an exception
                module.Event(_context, request.readyState, apm.LEVEL_NORMAL, apm.FLAG_LEAVE + apm.FLAG_WAIT, request.status, request.statusText);
              }
              catch (ex) { /* ignore */ }
              if ('function' === typeof callback) {
                module.Event(_context, 10, apm.LEVEL_NORMAL, apm.FLAG_ENTER);
                try {
                  callback(request, _context);
                }
                catch (e2) {
                  var msg2 = "apm.SendXMLHttpRequest user callback failed: " + e2.name + ": " + e2.message;
                  utils.error(e2, msg2);
                  module.Event(_context, apm.EVENT_ERROR, apm.LEVEL_NORMAL, apm.FLAG_NONE, msg2);
                }
                module.Event(_context, 11, apm.LEVEL_NORMAL, apm.FLAG_LEAVE);
              }
              if (async) {
                apm.ReleaseContext(_context);
              }
            }
          }
          else if ('function' === typeof callback) {
            callback(request, _context);
          }

          // only cleanup on async request! - sync requests still need the request object!
          if (request.readyState === 4) {
            request.onreadystatechange = nop;
            if (async) {
              request.abort();
              request = null;
            }
          }
        };
      }
      if (env.active) {
        module.Event(_context, 0, apm.LEVEL_NORMAL, apm.FLAG_ENTER + apm.FLAG_WAIT);
        token = apm.GetContext(_context);
        if (token) {
          request.setRequestHeader("x-apm-telemetry-context", token);
        }
      }
      request.send(value);
      if (env.active && !async) {
        try {
          module.Event(_context, 4, apm.LEVEL_NORMAL, apm.FLAG_LEAVE + apm.FLAG_WAIT, request.status, request.statusText);
        }
        catch (e) {
          var msg = "apm.SendXMLHttpRequest failed: " + e.name + ": " + e.message;
          utils.error(e, msg);
          module.Event(_context, apm.EVENT_ERROR, apm.LEVEL_NORMAL, apm.FLAG_NONE, msg);
        }
      }
    },
    GetXMLHTTPModule: function () {
      if (!cache.xmlhttpmodule) {
        cache.xmlhttpmodule = this.RegisterModule("XMLHttpRequest");
      }
      return cache.xmlhttpmodule;
    },
    GetAPMModule: function () {
      if (!cache.apimodule) {
        cache.apimodule = this.RegisterModule("app.telemetry API");
      }
      return cache.apimodule;
    },
    Flush: function (flushAllEvents, isUnload) {
      cache.flush(flushAllEvents, isUnload);
    },
    SetInterval: function (interval) {
      env.flushinterval = interval;
      utils.setupInterval();
    },
    SetTimeout: function (timeout) {
      env.flushtimeout = timeout;
      utils.setupTimeout();
    },
    _detectFscPlugin: function() {
      var $ = utils.get$();
      if ($ && $.apmdetectFscPlugin) {
        $.apmdetectFscPlugin();
      }
    },
    utils: {
      _base64Key: _base64Key,
      _resourceTypes: ["other", "link", "css", "script", "image", "object", "subdocument", "xmlhttprequest", "embed", "audio", "video", "svg",],
      buildURL: function(args) {
        var url = env.url;
        url += (-1 === url.indexOf('?')) ? args : encodeURIComponent(args);
        return url;
      },
      TraceResourceTiming: function(_ctx, r, basets) {
        var rt = apm.RegisterModule("RT"), modId = rt.id, type, url, level = 0, flagNone = 0, flagEnter = 1, flagLeave = 2;
        var _context = ++cache.contextid;
        function fixupEvent(event) {
          if (event[2] > 0) {
            var evt = _APMEvent(_context, modId, event[0], level, event[1]);
            evt[1] = event[2];
            if (event[0] === 1000) {
              evt.push(type, 0, "", url);
            }
            cache._add(evt);
          }
        }
        var evts, starttime = basets, dur = 0;
        if (r.duration) {
          dur = r.duration;
        } else if (r.responseEnd !== undefined && r.resourceStart !== undefined) {
          dur = r.responseEnd - r.resourceStart;
        }
        if (dur <= 0 || dur > 3600000) {   // 60 * 60 * 1000 ms
          return;   // skip invalid resource with duration > 1h
        }
        if (r.startTime) {
          starttime = basets + Math.floor(r.startTime);
          type = r.initiatorType || r.entryType || "unknown";
          url = r.name || "";
          evts = [
            [1, flagNone, starttime,],
            [2, flagEnter, r.redirectStart ? basets + Math.floor(r.redirectStart) : 0,],
            [3, flagLeave, r.redirectEnd ? basets + Math.floor(r.redirectEnd) : 0,],
            [4, flagNone, r.fetchStart ? basets + Math.floor(r.fetchStart) : 0,],
            [5, flagEnter, r.domainLookupStart ? basets + Math.floor(r.domainLookupStart) : 0,],
            [6, flagLeave, r.domainLookupEnd ? basets + Math.floor(r.domainLookupEnd) : 0,],
            [7, flagEnter, r.connectStart ? basets + Math.floor(r.connectStart) : 0,],
            [8, flagLeave, r.connectEnd ? basets + Math.floor(r.connectEnd) : 0,],
            [9, flagNone, r.secureConnectionStart ? basets + Math.floor(r.secureConnectionStart) : 0,],
            [10, flagEnter, r.requestStart ? basets + Math.floor(r.requestStart) : 0,],
            [11, flagNone, r.responseStart ? basets + Math.floor(r.responseStart) : 0,],
            [12, flagLeave, r.responseEnd ? basets + Math.floor(r.responseEnd) : 0,],
            [1000, flagNone, starttime,], // "type,content-length,content-type,url"));
          ];
        }
        else {
          starttime = r.resourceStart;
          type = utils._resourceTypes[r.type] || "unknown";
          url = r.url || "";
          evts = [
            [1, flagNone, r.resourceStart,],
            [2, flagEnter, r.redirectStart,],
            [3, flagLeave, r.redirectEnd,],
            [4, flagNone, r.fetchStart,],
            [5, flagEnter, r.domainLookupStart,],
            [6, flagLeave, r.domainLookupEnd,],
            [7, flagEnter, r.connectStart,],
            [8, flagLeave, r.connectEnd,],
            [9, flagNone, r.secureConnectionStart,],
            [10, flagEnter, r.requestStart,],
            [11, flagNone, r.responseStart,],
            [12, flagLeave, r.responseEnd,],
            [1000, flagNone, r.resourceStart,], // "type,content-length,content-type,url"));
          ];
        }
        // sort events by timestamp
        evts.sort(function (eva, evb) {
          var result = (eva[2] > 0 ? eva[2] : 0) - (evb[2] > 0 ? evb[2] : 0);
          if (result === 0) {
            result = eva[0] - evb[0];
          }
          return result;
        });
        var e = _APMContext(SWT_ENTRY_ATTACH_CONTEXT, _context, _ctx);
        e[1] = starttime;
        cache._add(e);
        var endtime = starttime;
        for (var i = 0; i < evts.length; i++) {
          var evt = evts[i];
          if (evt[2] > endtime) {
            endtime = evt[2];
          }
          fixupEvent(evt);
        }
        e = _APMReleaseContext(_context);
        e[1] = endtime;
        cache._add(e);
      },
      TraceNavigationTiming: function(_context) {
        var wt = apm.RegisterModule("WT"), modId = wt.id, t = window.performance.timing, resourceList, i, level = 0, flagNone = 0, flagEnter = 1, flagLeave = 2, dur = 0;
        if (t.loadEventEnd !== undefined && t.navigationStart !== undefined) {
          dur = t.loadEventEnd - t.navigationStart;
        }
        if (dur <= 0 || dur > 3600000) {   // 60 * 60 * 1000 ms
          return;   // skip invalid page-load-times with duration > 1h
        }
        function fixupEvent(event) {
          if (event[2] > 0) {
            var evt = _APMEvent(_context, modId, event[0], level, event[1]);
            evt[1] = event[2];
            cache._add(evt);
          }
        }
        var evts = [
          [1, flagNone, t.navigationStart,],
          [2, flagNone, t.unloadEventStart,],
          [3, flagNone, t.unloadEventEnd,],
          [4, flagNone, t.redirectStart,],
          [5, flagNone, t.redirectEnd,],
          [6, flagNone, t.fetchStart,],
          [7, flagEnter, t.domainLookupStart,],
          [8, flagLeave, t.domainLookupEnd,],
          [9, flagEnter, t.connectStart,],
          [10, flagLeave, t.connectEnd,],
          [11, flagNone, t.secureConnectionStart,],
          [12, flagEnter, t.requestStart,],
          [13, flagNone, t.responseStart,],
          [14, flagLeave, t.responseEnd,],
          [15, flagEnter, t.domLoading,],
          [16, flagNone, t.domInteractive,],
          [17, flagEnter, t.domContentLoadedEventStart,],
          [18, flagLeave, t.domContentLoadedEventEnd,],
          [19, flagLeave, t.domComplete,],
          [20, flagEnter, t.loadEventStart,],
          [21, flagLeave, t.loadEventEnd,],
        ];
        if (typeof window.performance.getResourceTimings === "function") {
          resourceList = window.performance.getResourceTimings();
        } else if (typeof window.performance.getEntriesByType === "function") {
          resourceList = window.performance.getEntriesByType("resource");
        } else if (typeof window.performance.webkitGetEntriesByType === "function") {
          resourceList = window.performance.webkitGetEntriesByType("resource");
        }
        if (resourceList && resourceList.length) {
          var _ctx = b64ctx(apm.LEVEL_LOG);
          var evt = _APMContext(SWT_ENTRY_GET_CONTEXT, _context, _ctx);
          evt[1] = t.navigationStart;
          cache._add(evt);
          for (i = 0; i < resourceList.length; i++) {
            utils.TraceResourceTiming(_ctx, resourceList[i], t.navigationStart);
          }
        }
        // sort events by timestamp
        evts.sort(function (eva, evb) {
          var result = (eva[2] > 0 ? eva[2] : 0) - (evb[2] > 0 ? evb[2] : 0);
          if (result === 0) {
            result = eva[0] - evb[0];
          }
          return result;
        });
        for (i = 0; i < evts.length; i++) {
          fixupEvent(evts[i]);
        }
      },
      isInt: function(n) {
        return n % 1 === 0 && n <= 9007199254740991;   // Number.MAX_SAFE_INTEGER
      },
      CreateContextToken: CreateContextToken,
      RestoreGUID: function () {
        var guid = null;
        try {
          if (window.localStorage) {
            guid = window.localStorage.getItem(apmguidKey);
          }
        } catch(e) {
          utils.warn("failed to access the localStorage");
        }
        if (!guid && document.cookie) {
          guid = ("" + document.cookie).match(/^(?:|.*\s)apmguid=([A-Za-z0-9]{32})(?:;\s.*|)$/);
          if (guid) {
            guid = guid[1];
          }
        }
        if (guid) {
          cache.guid = guid;
        }
      },
      StoreGUID: function(guid) {
        var stored = false;
        try {
          if (window.localStorage) {
            window.localStorage.setItem(apmguidKey, guid);
            stored = true;
          }
        }
        catch(ex) {
          utils.warn("cache.flush(): storing the apmguid in the localStorage failed");
        }
        if (!stored) {
          document.cookie = "apmguid=" + guid + "; Path=/" + ('https:' === location.protocol ? '; Secure' : '');
        }
      },
      ComputeTelemetryStatusKey: function(registration) {
        var name = [];
        name.push(telemetryStatusKeyPrefix);
        name.push(encodeURIComponent(registration.appname));
        name.push(encodeURIComponent(registration.appid));
        name.push(encodeURIComponent(registration.apptiername));
        name.push(encodeURIComponent(registration.apptierid));
        return name.join('#');
      },
      PersistTelemetryStatus: function(registration, data) {
        var key = this.ComputeTelemetryStatusKey(registration);
        try {
          window.localStorage.setItem(key, JSON.stringify({
            ts: ts(),
            data: data,
          }));
        }
        catch (ex) {
          this.error(ex, "utils.PersistTelemetryStatus(): caching telemetry status failed");
        }
      },
      RestoreTelemetryStatus: function(registration) {
        var key = this.ComputeTelemetryStatusKey(registration);
        try {
          var telemetryStatus = window.localStorage.getItem(key);
          if (null !== telemetryStatus) {
            telemetryStatus = JSON.parse(telemetryStatus);
            cache.processWebAPIResponse(telemetryStatus.data);
          }
        }
        catch (ex) {
          this.error(ex, "utils.RestoreTelemetryStatus(): restoring the cached telemetry status failed");
        }
        try {
          this.CleanupTelemetryStatus();
        }
        catch (ex2) {
          this.error(ex2, "utils.RestoreTelemetryStatus(): CleanupTelemetryStatus() failed");
        }
      },
      CleanupTelemetryStatus: function() {
        var minValidTimeStamp = ts() - (TELEMETRY_STATUS_VALID_DAYS * 86400 * 1000);
        for (var i = 0; i < window.localStorage.length; ++i) {
          var key = window.localStorage.key(i);
          if (telemetryStatusKeyPrefix === key.substring(0, telemetryStatusKeyPrefix.length)) {
            var ok = false;
            try {
              var item = JSON.parse(window.localStorage.getItem(key));
              ok = item.ts > minValidTimeStamp;
            }
            catch(_) {
              this.warn("utils.CleanupTelemetryStatus(): " + key + " failed to be inspected, will be removed.");
            }
            if (!ok) {
              window.localStorage.removeItem(key);
            }
          }
        }
      },
      Encode64: Encode64,
      Decode64: Decode64,
      getXHR: function () {
        if (window.XMLHttpRequest) {
          return new XMLHttpRequest();
        } else if (window.ActiveXObject) {
          return new ActiveXObject("Microsoft.XMLHTTP");
        } else {
          return new XMLHttpRequest();
        }
      },
      createReportDialog: function (_parentNode, _formOptions) {
        cache.dlgApi.createDialog(env.url, env.report, _formOptions, _parentNode, cache.dlgConfig, {
          cancelReportDialog: utils.cancelReportDialog,
          submitReportDialog: utils.submitReportDialog,
          apm: apm,
          hasform: cache.hasform || (_formOptions && _formOptions.formid),
          reg: cache.registration,
          loadJSONP: loadJSONP,
        });
      },
      cancelReportDialog: function (event, data) {
        var r = env.report, d, m, $ = utils.get$();
        d = $.extend(true, {}, r.data);
        m = d.metadata = d.metadata || {};
        m.infos = data.infos;
        m.files = data.files;
        m.fields = data.fields;
        d.description = data.description;
        if ((typeof r.oncancel === "function") && (false === r.oncancel(d))) {
          return false;
        }
        utils.removeReportDialog();
        return true;
      },
      get$: function () {
        var $ = apm.cache.$jq || window.jQuery || window.$ || null;
        return $;
      },
      removeReportDialog: function () {
        var r = env.report, d = r.data, plugin = r.plugin;
        d.screenshot = null;
        d.softwareinfo = null;
        d.metadata = null;

        if (r.pluginactive && plugin && typeof plugin.ClearTempFiles === "function") {
          try {
            plugin.ClearTempFiles();
          } catch (e) { }
        }
      },
      submitReportDialog: function (event, data) {
        var r = env.report, d, module, m, ctx, content, i, $ = utils.get$();
        d = $.extend(true, {}, r.data);
        d.description = data.description;
        m = data;
        m = d.metadata = d.metadata || {};
        m.infos = data.infos;
        m.files = data.files;
        m.fields = data.fields;
        if ((typeof r.onsubmit === "function") && (false === r.onsubmit(d))) {
          return false;
        }
        module = apm.GetAPMModule();
        ctx = d.contextid = apm.CreateContext(null, d.filter);
        module.Event(ctx, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_ENTER, "Sending app.telemetry feedback dialog content");
        apm.Report(d.contextid, d.filter, d.key, d.description, data.formid);
        // attach any further metadata
        for (i = 0; i < m.infos.length; i++) {
          if (m.infos[i] && m.infos[i].name && m.infos[i].value) {
            apm.ReportValue(d.contextid, d.key, m.infos[i].name, m.infos[i].value);
            module.Event(ctx, apm.EVENT_INFO, apm.LEVEL_DETAIL, apm.FLAG_NONE, "add ReportValue for report-key='" + d.key + "' with name='" + m.infos[i].name + "'");
          }
        }
        for (i = 0; i < m.fields.length; i++) {
          if (m.fields[i] && (m.fields[i].id || m.fields[i].name) && m.fields[i].value) {
            apm.ReportValue(d.contextid, d.key, (m.fields[i].id || m.fields[i].name), m.fields[i].value);
            module.Event(ctx, apm.EVENT_INFO, apm.LEVEL_DETAIL, apm.FLAG_NONE, "add ReportValue for report-key='" + d.key + "' with name='" + m.fields[i].name + "'");
          }
        }
        cache.flush(true);
        // get and attach any other files from metadata info
        for (i = 0; i < m.files.length; i++) {
          if (m.files[i] && m.files[i].filename && typeof m.files[i].getContent === "function" && m.files[i].checked) {
            content = m.files[i].getContent(m.files[i].filename, m.files[i]) || m.files[i].content;
            if (!m.files[i].mimeType) {
              m.files[i].mimeType = "text/plain";
            }
            if (content) {
              apm.ReportContent(d.key, m.files[i].filename, content, "base64", m.files[i].mimeType);
              module.Event(ctx, apm.EVENT_INFO, apm.LEVEL_DETAIL, apm.FLAG_NONE, "add ReportContent for report-key='" + d.key + "' with filename='" + m.files[i].filename + "' and size=" + content.length);
            }
          }
        }
        module.Event(ctx, apm.EVENT_INFO, apm.LEVEL_NORMAL, apm.FLAG_LEAVE, "Sending app.telemetry feedback dialog content done");
        apm.ReleaseContext(ctx);
        env.report.data.contextid = null;
        utils.removeReportDialog();
        return true;
      },
      setupInterval: function () {
        if (cache.initialized) {
          if (0 !== cache.flushintervalhandle) {
            window.clearInterval(cache.flushintervalhandle);
          }
          cache.flushintervalhandle = window.setInterval(cache.flush, env.flushinterval);
        }
      },
      setupTimeout: function () {
        if (cache.initialized) {
          if (0 === cache.flushtimeouthandle) {
            cache.flushtimeouthandle = window.setTimeout(cache.flush, env.flushtimeout);
          }
        }
      },
      arrayFromObject: function (obj) {
        var arr = [];
        for (var idx in obj) {
          if (obj.hasOwnProperty(idx)) {
            arr.push(obj[idx]);
          }
        }
        return arr;
      },
      error: function (exobject, message) {
        if ('function' === typeof env.exceptioncallback) {
          env.exceptioncallback(exobject, message);
        }
        else if (('undefined' !== typeof console) && ('function' === typeof console.warn)) {
          console.warn(message);
        }
      },
      warn: function (message) {
        if (('undefined' !== typeof console) && ('function' === typeof console.warn)) {
          console.warn(message);
        }
      },
      flushAllEvents: function () {
        cache.flush(true, true);
      },
    },
  };
  utils = apm.utils;

  defaultTransport = cache.transport = {
    send: function(url, data, success, error, async, isUnload) {
      var sent = false;
      if (isUnload && navigator.sendBeacon) {
        sent = navigator.sendBeacon(url, data);
        if (sent) {
          success({
            status: 200,
            statusText: "OK (beacon)",
          });
        }
      }
      if (!sent) {
        var request = utils.getXHR();
        if (request) {
          request.open("POST", url, !isUnload);
          request.onreadystatechange = function() {
            var response;
            if (4 === request.readyState) {
              try {
                response = {
                  status: request.status,
                  statusText: request.statusText || "Request failed",
                };
                if (200 === request.status) {
                  response.responseText = request.responseText;
                  success(response);
                }
                else {
                  error(response);
                }
              }
              catch(e) {
              }
              request.onreadystatechange = nop;
              request.abort();
              request = null;
            }
          };
          try {
            request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
          }
          catch (ex) {
            utils.warn('could not set request Content-Type header for telemetry data request');
          }
          request.send(data);
        }
      }
    },
  };

  if (window.performance && window.performance.timing && window.addEventListener) {
    navTCtxBackup = navTCtx = b64ctx(apm.LEVEL_LOG);
    window.addEventListener('load', function () {
      window.setTimeout(function () {
        // TODO: module "WT" or use a better name, but then make sure events are registered
        var t = window.performance.timing, e, contextid;
        if (env.active && env.includeNavigationTiming && navTCtxBackup) {
          contextid = ++cache.contextid;
          e = _APMContext(SWT_ENTRY_ATTACH_CONTEXT, contextid, navTCtxBackup);
          utils.TraceNavigationTiming(contextid);
          e = _APMReleaseContext(contextid);
          e[1] = t.loadEventEnd;
          cache._add(e);
          navTCtxBackup = null;
        }
      }, 100);
    }, false);
  }

  //expose API
  apm._apm = window.apm;
  window.apm = apm;
  window[expando] = apm;
} (this, document));

/* DEBUG code to trace softwaretelemetry API usage
if (window.console && window.console.groupCollapsed && window.console.trace && window.console.groupEnd) {
  for (var key in window.apm) {
    var _old = window.apm[key];
    if ('function' === typeof _old) {
      (function(key, _old){
        window.apm[key] = function() {
          console.groupCollapsed('APM.' + key + '(', arguments, ')');
          var r = _old.apply(this, arguments);
          console.groupCollapsed(key, r);
          console.trace();
          console.groupEnd();
          console.groupEnd();
          return r;
        };
      })(key, _old);
    }
  }
}
*/
return apm.NoConflict(true);
});